import { axios } from '@/libs/api.request';
import { Response } from '@/types/request.d';

interface GetTaskListParams {
    page_size: number,
    page: number,
    tab_type: '0' | '1', // 0-已完成、1-进行中
}

type TaskType =
    | 'export_contact_list' //  导出客户列表
    | 'import_script' // 导入话术库、
    | 'sync_fb_contact' // 同步fb客户
    | 'sync_ins_contact' // ins同步联系人
    | 'import_corpus' // 导入语料
    | 'sync_fb_contact_label' // Facebook同步联系人标签
    | 'export_whatsapp_app_group_relation_list' // WhatsApp App群成员导出
    | 'export_telegram_app_group_relation_list' // Telegram App群成员导出
    | 'export_session_list' // 会话列表导出
    | 'export_broadcast_detail_list' // 消息群发详情导出
    | 'export_broadcast_list' // 消息群发列表导出
    | 'export_telegram_app_list' // 集成-TG客户列表导出
    | 'export_tiktok_app_list' // 集成-TK客户列表导出
    | 'export_individual_whatsapp_list' // 集成-wsapp客户列表导出
    | 'export_whatsapp_platform_list' // 集成-wsapi-自助-客户列表导出
    | 'export_whatsapp_api_list' // 集成-wsapi-客户列表导出
    | 'export_whatsapp_third_party_list' // 集成-wsapi-第三方-客户列表导出
    | 'update_contact_black' // 批量拉黑到任务中心
    | 'submit_whatsapp_api_template' // WhatsApp API-提交模板
    | 'export_zalo_app_list' // 集成-Zalo客户列表导出
    | 'upload_fb_custom_audience' // 创建Facebook自定义受众
    | 'chat_update_label' // 在线聊天批量打标签
    | 'contact_update_label' // 客户列表批量更改标签
    | 'export_session_message_list' // 会话列表聊天记录导出
    | 'refresh_whatsapp_api_template' // WhatsApp API模版同步任务
    | 'session_tags' // 添加会话标签
    | 'WORK_WEIXIN_SYNC_CONTACT' // 企微同步联系人
    | 'export_online_log' // 导出在线日志
    | 'import_contact' // 联系人导入
    | 'export_fb_ad_insights' // 导出广告分析
    | 'export_update_contact_list' // 导出更新
    | 'import_update_contact' // 更新客户资料
    | 'whatsapp_check' // WhatsApp号码检测
    | 'whatsapp_api_modify_profile' // WhatsApp API-修改客户资料
    | 'whatsapp_api_sync_choose' // WhatsApp API账号同步任务
    | 'syn_order' // 同步订单
    | 'sync_custom_audience' // 自定义受众-更新数量
    | 'whatsapp_protocol_import' //  WhatsApp App 协议号 批量集成
    | 'export_messenger_list' // 集成-Messenger-账号列表导出
    | 'whatsapp_flows_sync' // WhatsApp flows 同步
    | 'messenger_create_template' // 提交 Messenger 模版
    | 'telegram_session_authorize' // 导入Telegram App 账号
    | 'upgrade_plugin_version' // 聊天插件升级
    | 'export_auto_flow_trigger_detail_list' // 自动化流程触发数据导出 - 流程列表
    | 'export_auto_flow_step_trigger_detail_list' // 自动化流程触发数据导出 - 流程数据
    ;

export interface TaskListItem {
    id: string;
    project_id: string;
    type: TaskType;
    status: '1' | '2' | '3' | '4' | '5'; // 1-进行中、2-成功、3-失败、4-取消中、5-取消
    sys_user_id: string;
    fail_code: string; // 错误状态码
    fail_reason: string; // 错误原因
    ext:{
        channel_phone_number: any;
        channel_name: any;
        group_id: any;
        group_name: any;
        url?: string;
        id?: string;
        page_id?: string;
        name?: string;
        error_num?: string;
        success_num?: string; // 成功数量 / messenger 模板提交
        error_list?: any[];
        title?: string;
        update_type?: 'add_black' | 'cancel_black'; // 拉入/移出黑名单状态
        add_user_count?: number; // 企微同步新增的用户数
        channel?: string; // 联系人导出的渠道
        total?: number; // 联系人导出: 总数
        incr_count?: number; // 联系人导出: 新增
        invalid_count?: number; // 联系人导出: 无效
        cover_count?: number; // 联系人导出: 覆盖
        skip_count?: number; // 联系人导出: 跳过
        phone?: string; // wsapi修改资料对应的手机号
        created?: string; // 新增
        updated?: string; // 更新
        fail_num?: number; // messenger 模板提交
        success_plugin_names?: string[]; // 聊天插件升级成功的插件名
        fail_plugin_names?: string[]; // 聊天插件升级失败的插件名
    };
    finished_time: string;
    cancel_time: string;
    created_time: string;
    updated_time: string;
    success_num: string;
    fail_num: string;
    handle_total: string;
}

interface GetTaskListData {
    list: TaskListItem[];
    page_size: number,
    page: number,
    total: number;
}

/**
 * 获取任务中心列表
 */
export const getTaskList = (params: GetTaskListParams) => axios.request<Response<GetTaskListData>>({
    url: '/sys/project/job-task/get-task-list',
    method: 'get',
    params,
});

/**
 *  取消任务
 * @param data : id-任务id
 */
export const cancelTask = (data: {id: string}) => axios.request({
    url: '/sys/project/job-task/cancel-task',
    method: 'post',
    data,
});

interface GetTaskParams {
    tab_type: '0' | '1'; // 0-已完成、1-进行中
    type: string;
}

interface GetTaskData {
    total: number;
}

/**
 * 获取任务数量
 */
export const getTask = (params: GetTaskParams) => axios.request<Response<GetTaskData>>({
    url: '/sys/project/job-task/get-task',
    method: 'get',
    params,
});
